import { PlanSubmissionStatus } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'

/**
 * 一覧の「ダウンロード」 を押せない理由と、 その示し方
 * (spec `plan-submit/procurement-plan-list.md` AC-PPL-027、 conventions.md「操作できない時のボタンの扱い」)。
 *
 * - `text`: 待てば押せる状態に戻るので、 非活性 + 理由の文を画面上に常に出す (conventions.md の 2)
 * - `tooltip`: この版は押せる状態に戻らないので、 理由はツールチップで示す (conventions.md の 3)
 */
export type DownloadBlockReason = {
  key: string
  display: 'text' | 'tooltip'
}

/**
 * 作成中は作成が終われば押せる。 作成失敗は直し方を計画詳細の誘導メッセージ (AC-PLC-020-2) が
 * 示すので、 ここでは理由だけをツールチップで示す。 ここに無い非活性の状態 (編集中 等) は理由を出さない。
 * 活性可否そのものは `canDownloadXml` が決める。
 */
const DOWNLOAD_BLOCK_REASONS: Partial<
  Record<PlanSubmissionStatus, DownloadBlockReason>
> = {
  [PlanSubmissionStatus.GENERATING]: {
    key: 'page:planSubmission.downloadBlockReason.generating',
    display: 'text',
  },
  [PlanSubmissionStatus.GENERATION_FAILED]: {
    key: 'page:planSubmission.downloadBlockReason.generationFailed',
    display: 'tooltip',
  },
}

export function downloadBlockReason(
  status: PlanSubmissionStatus,
): DownloadBlockReason | undefined {
  return DOWNLOAD_BLOCK_REASONS[status]
}
